export default {
  SMALL: 400,
  MEDIUM: 560,
  LARGE: 1000,
};
